import {
  Box,
  Typography,
} from '@mui/material';
import { heritageColors } from '../../../../heritageTheme.ts';
import { getIconById } from '../../iconOptions';

const Crown = ({ data, title = 'נציב הקהילה', showTitle = false }) => {
  // קבלת האייקון הנבחר או ברירת מחדל (כוכב)
  const IconComponent = getIconById(data.iconId || 'star');
  return (
    <Box sx={{
      p: 3,
      textAlign: 'center',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      direction: 'rtl',
    }}>
      {/* Title */}
      {showTitle && (
        <Typography sx={{
          fontSize: '1.5rem',
          fontWeight: 700,
          color: heritageColors.navy,
          mb: 2,
        }}>
          {title}
        </Typography>
      )}

      {/* Icon */}
      <Box sx={{
        mb: 2,
        display: 'flex',
        justifyContent: 'center',
      }}>
        <IconComponent sx={{
          fontSize: 64,
          color: heritageColors.gold,
        }} />
      </Box>

      {/* Label */}
      <Typography sx={{
        color: heritageColors.slate,
        fontSize: '0.9rem',
        mb: 0.5,
      }}>
        {data.type}
      </Typography>

      {/* Name */}
      <Typography variant="h4" sx={{
        color: heritageColors.navy,
        fontWeight: 700,
        mb: 1,
      }}>
        {data.name}
      </Typography>

      {/* Dedication */}
      <Typography sx={{
        color: heritageColors.slate,
        fontSize: '1rem',
        whiteSpace: 'pre-line',
      }}>
        {data.dedication}
      </Typography>
    </Box>
  );
};

export default Crown;